import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]
  static values = { open: { type: Boolean, default: false } }

  declare readonly stepTargets: HTMLElement[]
  declare openValue: boolean

  private currentIndex = 0

  connect() {
    // アンカーリンクで遷移した場合（URLにハッシュが含まれている場合）はモーダルを表示しない
    const hasHash = window.location.hash && window.location.hash.length > 0
    if (this.openValue && !hasHash) {
      this.open()
    } else {
      this.hide()
    }
  }

  next(event: Event) {
    event.preventDefault()
    this.currentIndex += 1
    if (this.currentIndex >= this.stepTargets.length - 1) {
      this.showStep(this.stepTargets.length - 1)
    } else {
      this.showStep(this.currentIndex)
    }
  }

  prev(event: Event) {
    event.preventDefault()
    this.currentIndex -= 1
    if (this.currentIndex <= 0) {
      this.currentIndex = 0
    }
    this.showStep(this.currentIndex)
  }

  finish(event: Event) {
    event.preventDefault()
    this.close()
  }

  close(event?: Event) {
    if (event) event.preventDefault()
    this.hide()
  }

  private open() {
    this.element.classList.add("is-open")
    this.currentIndex = 0
    this.showStep(this.currentIndex)
  }

  private hide() {
    this.element.classList.remove("is-open")
  }

  private showStep(index: number) {
    this.stepTargets.forEach((el, i) => {
      if (i === index) {
        el.classList.add("is-active")
      } else {
        el.classList.remove("is-active")
      }
    })
    this.resetScroll()
  }

  private resetScroll() {
    const container = this.element.querySelector<HTMLElement>(
      ".c-onboarding-modal__dialog__container"
    )
    if (container) {
      container.scrollTop = 0
    }
  }
}


